import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import HorizontalTabs from "../../tabs/horizontalTabs";
import ActionModal from "../modals";
import ActionModalContent from "../modals/modalContent";
import {
  fetchEnrolleesPendingAppointment,
  getEnrolleesAppointment,
} from "../../../store/appointment";
import { useDispatch, useSelector } from "react-redux";
import {
  getFormatedDate,
  getFormattedTimeStamp,
} from "../../../utils/constants";
import Loader from "../../common/Loader";
import { updateRequestStatusById } from "../../../store/enrollee";
import notification from "../../common/Alert";

const tabLabels = ["Principal Directory", "Dependent Directory"];

export default function PendingEnroleesAppointment() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch();
  const enrolleesData = useSelector(getEnrolleesAppointment);
  let [pageNumber, setPageNumber] = useState(1);
  let [pageLists, setPageLists] = useState(10);
  const { activetab } = useParams();

  const tabNameToIndex = {
    0: "principal-directory",
    1: "dependent-directory",
  };

  const indexToTabName = {
    "principal-directory": 0,
    "dependent-directory": 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    history.push(`/hmo/dashboard/appointment/${tabNameToIndex[newValue]}`);
    setTabIndex(newValue);
  };

  useEffect(() => {
    const fetchEnrollees = async () => {
      dispatch(fetchEnrolleesPendingAppointment(pageLists, pageNumber));
    };
    fetchEnrollees();
  }, [dispatch, pageNumber, pageLists]);

  const incrementPageNumber = async () => {
    setPageNumber((pageNumber += 1));
    await dispatch(fetchEnrolleesPendingAppointment(pageLists, pageNumber));
  };

  const decrementPageNumber = async () => {
    setPageNumber((pageNumber -= 1));
    await dispatch(fetchEnrolleesPendingAppointment(pageLists, pageNumber));
  };

  const handleSelectNumber = ({ target }) => {
    if (target.value === "30") {
      setPageLists(30);
    } else if (target.value === "20") {
      setPageLists(20);
    } else {
      setPageLists(10);
    }
  };

  const accept_request = async (id) => {
    setModal(false);
    const acceptRequest = await dispatch(
      updateRequestStatusById(id, "approved", "hospital-appointments")
    );
    notification.notication("success", acceptRequest?.payload?.message, "", {
      position: "top-right",
    });
    await dispatch(fetchEnrolleesPendingAppointment(10, 1));
  };

  const decline_request = async (id) => {
    setModal(false);
    const declineRequest = await dispatch(
      updateRequestStatusById(id, "declined", "hospital-appointments")
    );
    notification.notication("success", declineRequest.payload.message, "", {
      position: "top-right",
    });
    await dispatch(fetchEnrolleesPendingAppointment(10, 1));
  };

  const handleOpenConfirmModal = (id, enrolleeName) => {
    setModal(true);
    setContent(
      <ActionModalContent
        approveTextTop={
          <p>
            You are about to confirm <b>{enrolleeName}</b> appointment request.
            Would you like to proceed?
          </p>
        }
        onApprove={() => accept_request(id)}
        onApproveSection
        onDecline={() => setModal(false)}
      />
    );
  };

  const handleOpenDeclineModal = (id, enrolleeName) => {
    setModal(true);
    setContent(
      <ActionModalContent
        declineTextTop={
          <p>
            You are about to decline <b>{enrolleeName}</b> appointment request.
            Would you like to proceed?
          </p>
        }
        onDecline={() => setModal(false)}
        onApproveSection
        modal={
          <ActionModal
            content={content}
            modalTitle={modalTitle}
            open={modal}
            close={() => setModal(false)}
          />
        }
        onApprove={() => decline_request(id)}
      />
    );
    setModalTitle("Decline Appointment");
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleSearchAndFilter = enrolleesData.pendingAppointment.filter(
    (searched) => {
      if (search === " ") {
        return searched;
      } else if (
        searched.first_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched.last_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched.phone_number.includes(search && search.toLowerCase())
      ) {
        return searched;
      } else {
        return null;
      }
    }
  );

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = () => {
    const newSelecteds = enrolleesData.pendingAppointment.map((n) => n.id);
    setSelected(newSelecteds);
    return;
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "2rem",
          justifyContent: "space-between",
        }}
      >
        <SearchOnly handleSearch={handleChange} searchWord={search} />
        <HorizontalTabs
          tabData={tabLabels}
          tabIndex={tabIndex}
          onTabChange={onChangeTabIndex}
        />
      </div>
      <Loader visible={enrolleesData.loading} />
      <TableItem
        userType="Enrollee"
        modal={
          <ActionModal
            content={content}
            modalTitle={modalTitle}
            open={modal}
            close={() => setModal(false)}
          />
        }
        checkBoxes
        tabHeadLabel={[
          "Enrollee",
          "Phone Number",
          "Hospital Name",
          "Date",
          "Time",
          "Date created",
          "Time Created"
        ]}
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected.length}
        rowCount={enrolleesData.pendingAppointment.length}
        numSelected={selected.length}
        onSelectAllClick={handleSelectAllClick}
        currentPage={enrolleesData.currentPage}
        toPage={enrolleesData.toPage}
        totalPage={enrolleesData.total}
        handleIncrement={() => incrementPageNumber()}
        handleDecrement={() => decrementPageNumber()}
        disabledIncrement={pageNumber >= enrolleesData.lastPage}
        disabledDecrement={pageNumber <= 1}
        handleSelectPageNumber={handleSelectNumber}
        pageSelectValue={pageLists}
        tabBodyData={handleSearchAndFilter.map((item, i) => {
          const isItemSelected = isSelected(item.id);
          const labelId = `enhanced-table-checkbox-${i}`;
          return (
            <TablesData
              labelId={labelId}
              handleItemClick={(event) => handleClick(event, item.id)}
              aria-checked={isItemSelected}
              isItemSelected={isItemSelected}
              key={i}
              checkBoxes
              image
              imageUrl={item.enrolee_photo}
              imgInitials={
                item?.first_name.slice(0, 1) + item?.last_name.slice(0, 1)
              }
              enroleeName={item.first_name + " " + item.last_name}
              enroleeId={item.enrollee_id}
              listItem={[
                item.phone_number,
                item.hospital_name,
                getFormatedDate(item.appointment_date, "YYYY/MMM/DD"),
                getFormattedTimeStamp(item.appointment_date),
                getFormatedDate(item.created_at, "YYYY/MMM/DD"),
                getFormattedTimeStamp(item.created_at)
              ]}
              action={
                <AppMenu
                  menu_name_or_icon={<MoreHorizIcon />}
                  item_names={[
                    {
                      "View More": () =>
                        history.push(
                          `/hmo/dashboard/enrollee/appointments/accept/${
                            item.enrollee_primary_key || item.id
                          }`
                        ),
                    },
                    {
                      "Confirm Appointment": () =>
                        handleOpenConfirmModal(
                          item.id,
                          item.first_name + " " + item.last_name
                        ),
                    },
                    {
                      "Decline Appointment": () =>
                        handleOpenDeclineModal(
                          item.id,
                          item.first_name + " " + item.last_name
                        ),
                    },
                  ]}
                />
              }
            />
          );
        })}
        tablePagination
      />
    </>
  );
}
